import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6bb40888 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _2e1857d2 = () => interopDefault(import('../pages/benefit.vue' /* webpackChunkName: "pages/benefit" */))
const _67260295 = () => interopDefault(import('../pages/business.vue' /* webpackChunkName: "pages/business" */))
const _f6a80c20 = () => interopDefault(import('../pages/complications.vue' /* webpackChunkName: "pages/complications" */))
const _5150dadb = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _416f4e98 = () => interopDefault(import('../pages/develop.vue' /* webpackChunkName: "pages/develop" */))
const _11406772 = () => interopDefault(import('../pages/game.vue' /* webpackChunkName: "pages/game" */))
const _fe7a4a36 = () => interopDefault(import('../pages/honor.vue' /* webpackChunkName: "pages/honor" */))
const _49123cb0 = () => interopDefault(import('../pages/honor/index.vue' /* webpackChunkName: "pages/honor/index" */))
const _6c841d52 = () => interopDefault(import('../pages/landing.vue' /* webpackChunkName: "pages/landing" */))
const _cbf4cb5e = () => interopDefault(import('../pages/life.vue' /* webpackChunkName: "pages/life" */))
const _98129ab0 = () => interopDefault(import('../pages/news.vue' /* webpackChunkName: "pages/news" */))
const _438c9b2b = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _314d6c53 = () => interopDefault(import('../pages/news/_id.vue' /* webpackChunkName: "pages/news/_id" */))
const _72eb23ea = () => interopDefault(import('../pages/statement.vue' /* webpackChunkName: "pages/statement" */))
const _3f0392ed = () => interopDefault(import('../pages/statement/index.vue' /* webpackChunkName: "pages/statement/index" */))
const _db7926d6 = () => interopDefault(import('../pages/statement/_id.vue' /* webpackChunkName: "pages/statement/_id" */))
const _e9283966 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _6bb40888,
    name: "about"
  }, {
    path: "/benefit",
    component: _2e1857d2,
    name: "benefit"
  }, {
    path: "/business",
    component: _67260295,
    name: "business"
  }, {
    path: "/complications",
    component: _f6a80c20,
    name: "complications"
  }, {
    path: "/contact",
    component: _5150dadb,
    name: "contact"
  }, {
    path: "/develop",
    component: _416f4e98,
    name: "develop"
  }, {
    path: "/game",
    component: _11406772,
    name: "game"
  }, {
    path: "/honor",
    component: _fe7a4a36,
    children: [{
      path: "",
      component: _49123cb0,
      name: "honor"
    }]
  }, {
    path: "/landing",
    component: _6c841d52,
    name: "landing"
  }, {
    path: "/life",
    component: _cbf4cb5e,
    name: "life"
  }, {
    path: "/news",
    component: _98129ab0,
    children: [{
      path: "",
      component: _438c9b2b,
      name: "news"
    }, {
      path: ":id",
      component: _314d6c53,
      name: "news-id"
    }]
  }, {
    path: "/statement",
    component: _72eb23ea,
    children: [{
      path: "",
      component: _3f0392ed,
      name: "statement"
    }, {
      path: ":id",
      component: _db7926d6,
      name: "statement-id"
    }]
  }, {
    path: "/",
    component: _6c841d52,
    name: "index-v2"
  }, {
    path: "/index-v1",
    component: _e9283966,
    name: "index-v1"
  }, {
    path: "/index",
    redirect: "/"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
